export const toSessionIdFromWindow = () =>
  typeof window !== 'undefined' && (window as any).amplitude
    ? (window as any)?.amplitude?.getInstance()?._sessionId
    : undefined;
